import React from 'react'

import cn from 'classnames'

import s from './Content.module.scss'

type Props = {
  children: React.ReactNode
  className?: string
}

const Content = ({ children, className }: Props) => {
  return (
    <section className={cn(s.content, className && s[`${className}`])}>
      {children}
    </section>
  )
}

export default Content
